import { ApplicationState } from '@/redux/stores/types'

import { IAction } from '../actions/action-helpers'
import { AuthTypes, MyUserRolesTypes } from '../actions/actions.types'

type MyUserRolesState = ApplicationState['myUserRoles']

function myUserRolesReducer(state: MyUserRolesState = [], action: IAction): MyUserRolesState {
	switch (action.type) {
		case MyUserRolesTypes.GetMyUserRoles.SUCCESS:
			return action.payload
		case MyUserRolesTypes.AddToMyUserRoles:
			return state.concat([action.payload])
		case MyUserRolesTypes.RemoveFromMyUserRoles:
			return state.filter((r) => r.id !== action.payload.userRoleId)
		case AuthTypes.LogoutDone:
			return []
	}
	return state
}

export default myUserRolesReducer
